import { CreateEngagementDialog } from "@/components/advisor/CreateEngagementDialog";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { LoadingState } from "@/components/ui/loading-state";
import { useEngagements } from "@/hooks/use-advisor";
import { cn } from "@/lib/utils";
import {
	Link,
	Outlet,
	createFileRoute,
	useLocation,
} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/advisor")({
	component: AdvisorLayout,
});

function AdvisorLayout() {
	const { t } = useTranslation("advisor");
	const { data, isLoading } = useEngagements();
	const location = useLocation();
	const [createOpen, setCreateOpen] = useState(false);

	const engagements = data?.engagements ?? [];

	return (
		<div className="flex h-full overflow-hidden">
			<aside className="w-72 shrink-0 border-r flex flex-col">
				<div className="flex items-center justify-between p-3 border-b">
					<h2 className="text-sm font-medium">{t("engagements")}</h2>
					<Button size="sm" onClick={() => setCreateOpen(true)}>
						<Plus className="h-4 w-4 mr-1" />
						{t("new_engagement")}
					</Button>
				</div>
				<div className="flex-1 overflow-y-auto">
					{isLoading && <LoadingState variant="spinner" />}
					{engagements.map((e) => {
						const href = `/advisor/${e.id}`;
						const active = location.pathname === href;
						return (
							<Link
								key={e.id}
								to="/advisor/$id"
								params={{ id: e.id }}
								className={cn(
									"block px-3 py-2 border-b text-sm hover:bg-accent",
									active && "bg-accent",
								)}
							>
								<div className="font-medium truncate">{e.title}</div>
								<div className="flex items-center gap-1 mt-0.5 text-xs text-muted-foreground">
									<Badge variant="outline">{t(`stage_${e.stage}`)}</Badge>
									<span>{t(`status_${e.status}`)}</span>
								</div>
							</Link>
						);
					})}
				</div>
			</aside>
			<div className="flex-1 overflow-y-auto">
				<Outlet />
			</div>
			<CreateEngagementDialog open={createOpen} onOpenChange={setCreateOpen} />
		</div>
	);
}
